var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"exporo-adobe-captivate-frame"},[_c('iframe',{ref:"iframe",style:(_vm.getStyle()),attrs:{"src":_vm.getSrc(),"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }